<template>
  <div>
    <page-header>
      <h2>Реестр соискателей</h2>
      <template #actions>
        <div class="d-flex actions">
          <button-component
            kind="tertiary"
            :class="{ filtered: isFiltered }"
            @click="modals.filter = !modals.filter"
          >
            <template #prepend>
              <icon-component class="mr-2" name="filter" />
            </template>
            Фильтр
          </button-component>
        </div>
      </template>
    </page-header>

    <section class="content">
      <template v-if="page.items?.length">
        <div class="table-inner">
          <table class="table-custom">
            <thead>
              <tr>
                <th width="50px"></th>
                <th width="5%" class="text-center">№</th>
                <th>ФИО</th>
                <th>Статус</th>
                <!-- <th>Дата начала статуса</th> -->
                <th>Место работы</th>
                <th>Телефон</th>
                <th>E-mail</th>
                <th>Резюме</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in page.items"
                :key="item.id"
                v-on:dblclick="editCard(item.id)"
              >
                <td>
                  <menu-component class="actions" :actions="actions(item)" />
                </td>
                <td class="text-center">{{ page.firstItemNumber + index }}</td>
                <td>
                  {{ item.patient.surname }} {{ item.patient.name }}
                  {{ item.patient.patronimic }}
                </td>
                <td>{{ getStatus(item) }}</td>
                <!-- <td></td> -->
                <td>
                  {{ getWork(item) }}
                </td>
                <td>{{ item.patient.phone }}</td>
                <td>{{ item.patient.email }}</td>
                <td>
                  <file-download :file="item.resumeFile" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="page.pagesTotal > 1">
          <Pagination
            :page-count="page.pagesTotal"
            :current-page="page.pageNumber"
            @change="onPageChange($event)"
          />
        </div>
        <div>
          <PageCounter :isFiltered="isFiltered" :totalCount="totalCount" :filteredCount="page.itemsTotal" />
        </div>
      </template>
      <template v-else>
        <EmptyListMessage />
      </template>
      <section class="modals">
        <transition name="filter">
          <div class="filter" v-if="modals.filter">
            <ApplicantFilters
              v-bind:filters="filters"
              v-on:apply="onFiltersApply($event)"
              v-on:reset="onFiltersReset($event)"
            />
          </div>
        </transition>
      </section>
    </section>
  </div>
</template>
<script>
import API from "../api/applicant";
import ApplicantFilters from "../components/ApplicantFilters.vue";
import ButtonComponent from "@/common/ui/ButtonComponent";
import PageHeader from "@/common/components/page/PageHeader";
import IconComponent from "@/common/ui/IconComponent";
import Constants from "@/common/constants";
import EmptyListMessage from "@/common/components/EmptyListMessage";
import FileDownload from "@/common/components/FileDownload";
import MenuComponent from "@/common/ui/components/page/MenuComponent";
import filtermanager from "@/common/mixins/filtermanager";
import security from "@/common/mixins/security";
import PageCounter from "@/common/components/PageCounter";

export default {
  name: "ApplicantList",
  components: {
    MenuComponent,
    PageHeader,
    ButtonComponent,
    IconComponent,
    ApplicantFilters,
    EmptyListMessage,
    FileDownload,
    PageCounter
  },
  mixins: [filtermanager, security],
  data() {
    return {
      request: {
        pageNumber: 1,
        pageSize: Constants.pageSize
      },
      filters: {
        fio: ""
      },
      page: {},
      modals: {
        filter: false
      },
      isFiltered: false,
      canViewVacancy: false,
      canEditVacancy: false,
      totalCount: 0
    };
  },
  created() {
    this.getAccessMatrix([Constants.VacancyView, Constants.VacancyEdit]).then(
      response => {
        this.canViewVacancy = response.data[Constants.VacancyView];
        this.canEditVacancy = response.data[Constants.VacancyEdit];
      }
    );
    const self = this;
    API.search({ pageNumber: 1, pageSize: 1}).then(function (response) {
      self.totalCount = response.data.itemsTotal;
    });
    this.loadPage();
  },
  methods: {
    viewCard(id) {
      this.$router.push({
        name: "cardApplicant",
        params: { id: id, action: "view" }
      });
    },
    editCard(id) {
      if (this.canEditVacancy) {
        this.$router.push({
          name: "cardApplicant",
          params: { id: id, action: "edit" }
        });
      } else {
        this.viewCard(id);
      }
    },
    actions(item) {
      let result = [];
      if (this.canViewVacancy) {
        result.push({
          title: "Просмотр",
          icon: "eye",
          click: () => this.viewCard(item.id)
        });
      }
      if (this.canEditVacancy) {
        result.push({
          title: "Редактировать",
          icon: "pen",
          click: () => this.editCard(item.id)
        });
      }
      return result;
    },
    onPageChange(pageNumber) {
      this.request.pageNumber = pageNumber;
      this.loadPage();
    },
    loadPage() {
      const filter = this.loadFilter();
      if (filter) {
        this.filters = filter;
        this.isFiltered = true;
      }
      var params = Object.assign(this.filters, this.request);
      API.search(params).then(response => {
        this.page = response.data;
      });
    },
    onFiltersApply(filters) {
      this.filters = filters;
      this.request.pageNumber = 1;
      this.modals.filter = false;
      this.saveFilter(this.filters);
      this.isFiltered = true;
      this.loadPage();
    },
    onFiltersReset(filters) {
      this.filters = filters || {};
      this.request.pageNumber = 1;
      this.modals.filter = false;
      this.removeFilter();
      this.isFiltered = false;
      this.loadPage();
    },
    getWork(item) {
      if (item.workType == 1) return item.workOrganization;
      if (item.workType == 2) return "индивидуальный предприниматель";
      if (item.workType == 3) return "самозанятый";
      if (item.workType == 4) return "нет постоянного места работы";

      return "";
    },
    getStatus(item) {
      if (item.isSearchWork && !item.isWorkNow) return "Активный";
      if (item.isSearchWork && item.isWorkNow) return "Трудоустроен+";
      if (!item.isSearchWork && item.isWorkNow) return "Трудоустроен-";
      if (!item.isSearchWork && !item.isWorkNow) return "Остановлен";

      return "";
    }
  }
};
</script>
<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.content {
  padding: 16px 16px 0 16px;
  position: relative;
  overflow-y: visible;

  .filter {
    position: absolute;
    width: 350px;
    height: auto;
    top: 0;
    right: 0;
    overflow: hidden;
    background-color: transparent;
    opacity: 1;
    transition: opacity 0.2s;
  }

  .filter-enter, .filter-leave-to /* .fade-leave-active below version 2.1.8 */
 {
    opacity: 0;
  }
}
.filtered {
  color: $red;
  &:hover {
    color: $red-dark;
  }
}
</style>
